var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.76 177.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.79,177.43c-11.27,0-11.27-12.49-22.55-12.49S256,177.43,244.69,177.43s-11.27-12.49-22.55-12.49-11.27,12.49-22.55,12.49S188.32,164.94,177,164.94s-11.27,12.49-22.55,12.49c-10.41,0,15.28-131.65,15.28-131.65A52,52,0,0,1,221.42,0h1.45a52,52,0,0,1,51.65,45.78S307.48,177.43,289.79,177.43Z",
    fill: "#d0def2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.71,61.29A5.73,5.73,0,1,0,197,55.56,5.74,5.74,0,0,0,202.71,61.29Z",
    fill: "#384886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.32,61.29a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,244.32,61.29Z",
    fill: "#384886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,73.78c6.32,0,11.44-1.87,11.44-4.16s-5.12-4.17-11.44-4.17-11.43,1.87-11.43,4.17S184.6,73.78,190.91,73.78Z",
    fill: "#d37b28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.48,73.78c6.32,0,11.44-1.87,11.44-4.16s-5.12-4.17-11.44-4.17-11.43,1.87-11.43,4.17S250.17,73.78,256.48,73.78Z",
    fill: "#d37b28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,84c0,6.07-3.81,11-8.5,11S215,90.07,215,84s3.81-11,8.5-11S232,77.93,232,84Z",
    fill: "#384886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,171.77q-13.76,0-20-7.46-6.28-7.69-6.29-26.56H29.82q-15.13,0-22.6-7.22Q0,123.3,0,111.89A39,39,0,0,1,6.29,90Q22.84,64.12,43.57,34.06q12.12-17.7,33.32-17.7l20.27.23q17,0,23.07,5.82,6.06,5.6,6.06,19.81v61.51q10,.93,13.74,4.89t3.73,12.59q0,8.85-4,12.34-4,3.27-13.51,4,0,18.4-6.76,26.33T99.26,171.77ZM72.7,104.66,73.4,55,42.17,104.66Z",
    fill: "#293664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26,171.77q-13.75,0-20-7.46-6.29-7.69-6.29-26.56H331.82q-15.13,0-22.6-7.22Q302,123.3,302,111.89A39,39,0,0,1,308.29,90q16.54-25.86,37.28-55.92,12.12-17.7,33.32-17.7l20.27.23q17,0,23.07,5.82,6.06,5.6,6.06,19.81v61.51q10,.93,13.74,4.89t3.73,12.59q0,8.85-4,12.34-4,3.27-13.51,4,0,18.4-6.76,26.33T401.26,171.77ZM374.7,104.66,375.4,55l-31.23,49.63Z",
    fill: "#293664"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPage);
export default __webpack_public_path__ + "static/media/noPage.c05302f1c59b1d5c1c4636c33bf68cfa.svg";
export { ForwardRef as ReactComponent };